import { SpinnerIcon } from './icons.jsx';

// A neutral full-screen wait: a centred spinner (the app's ActivityIndicator
// moment) with the message for assistive tech. Used where the destination is not
// yet known — before the auth session has resolved, or while a zone deep link
// waits for the account to be seeded — so a screen-shaped skeleton would guess
// wrong. Screens with a known shape use PropertySkeleton instead.
export default function LoadingScreen({ message = 'Loading…' }) {
  return (
    <main className="app-shell loading-screen" aria-busy="true">
      <p role="status" className="visually-hidden">
        {message}
      </p>
      <span className="loading-screen__spinner" aria-hidden="true">
        <SpinnerIcon />
      </span>
    </main>
  );
}
